import {Vue, Component, Prop, PropSync, Provide, ProvideReactive, Watch} from 'vue-property-decorator';
import { Validator } from "vee-validate";
import {IndieLogin} from "../../../services/indie-login";
import store from "@/store";

const v = new Validator();

@Component<LoginPopupComponent>({
  components: ({})
})
export default class LoginPopupComponent extends Vue {
  @Prop() private openLoginPopup!: Function;
  @Prop() private indieLogin!: IndieLogin;

  public email: string = "";
  public password: string = "";
  public isFormValid:boolean = false;

  public readonly currentURL = location.href;
  public readonly passRecoveryURL = LoginPopupComponent.accountPasswordRecoveryUrl;
  public readonly signUpURL = LoginPopupComponent.accountSignupUrl;
  public readonly facebookURL = LoginPopupComponent.accountFacebookUrl;
  public readonly googleURL = LoginPopupComponent.accountGoogleUrl;
  public readonly loginURL = LoginPopupComponent.accountLoginUrl;

  constructor() {
    super();
  }

  mounted() {
    return true;
  }

  created() {
    return true;
  }

  destroyed() {
    return true;
  }

  updated() {
    return true;
  }

  public static get accountSignupUrl(){
    return process.env.VUE_APP_ACCOUNT_URL_SIGNUP_BASE + '?referer=' + encodeURIComponent(location.href);
  }

  public static get accountPasswordRecoveryUrl(){
    return process.env.VUE_APP_ACCOUNT_URL_PASSWORD_RECOVERY_BASE + '?referer=' + encodeURIComponent(location.href);
  }

  public static get accountFacebookUrl(){
    return process.env.VUE_APP_ACCOUNT_URL_FB_LOGIN + '&referer=' + encodeURIComponent(location.href);
  }

  public static get accountGoogleUrl(){
    return process.env.VUE_APP_ACCOUNT_URL_GOOGLE_LOGIN + '&referer=' + location.href;
  }

  public static get accountLoginUrl(){
    return process.env.VUE_APP_ACCOUNT_URL_LOGIN;
  }

  public validate() {
    this.$validator.validateAll().then(result => {
      if (result) {
        this.isFormValid = true;
        return;
      }
      this.isFormValid = false;
    });
  }

  public navigateTo(url:string){
    window.location.href = url
  }

  private get affiliateLogo(): string{
    if(store.state.affiliateViewData){
      return store.state.affiliateViewData.logo;
    }
    return '';
  }


}
